import { render } from "./portal-login.vue?vue&type=template&id=e7a50a68"
import script from "./portal-login.vue?vue&type=script&lang=js"
export * from "./portal-login.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__